import { MouseEvent as ReactMouseEvent } from 'react'

/**
 * True when the browser's default anchor behavior should be preserved instead of
 * our in-app (JS) handling: a modifier key is held (open in new tab/window/download)
 * or the click did not come from the main button.
 */
export const isModifiedClickEvent = (event: ReactMouseEvent): boolean =>
  event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0
